import React from "react"
import { useDispatch } from "react-redux"
import dayjs from "dayjs"
import { Box, Stack, Button } from "@mui/material"
import GenericHeaderReturnButton from "../../../components/GenericHeaderReturnButton"
import PackagingExecutionHeader from "../PackagingExecutionHeader"
import PackagingExecutionResume from "../packagingExecutionToValidate/PackagingExecutionResume"
import PackagingExecutionSectionsResume from "../packagingExecutionDone/PackagingExecutionSections"
import PEPackagings from "../packagingExecutionTodo/PEPackagings"
import PEStepper from "../PEStepper"
import PEBlockHead from "../packagingExecutionTodo/PEBlockHead"
import PEGazTest from "../packagingExecutionTodo/PEGazTest"
import PackagingByBrandAndTypeTable from "../PackagingByBrandAndTypeTable"
import PackagingExecutionFooter from "../PackagingExecutionFooter"
import { showPackagingExecutionRead } from "../../../actions/PackagingExecution/packagingExecution"
import { showPackagingExecution } from "../../../actions/PackagingExecution/packagingExecution" // tu l’as déjà
import { ACTIVE_KFC_BRANDS } from "../../../utils"
import { getFitCornerTag } from "../../../utils/productTagsUtils"
import { getOrderedPEPackagingsWithNoTypes, getNextToDoRecipe } from "../../../utils/packagingExecutionUtils"
import { hasCappedPackaging } from "../../../utils/testGaz"

const PackagingExecutionDone = ({ packagingExecution, packagingExecutions, selectedSite, selectedDate, hasSubStatus, gazTests = [] }) => {
	const dispatch = useDispatch()

	const goToPackagingExecutionRead = () => {
		dispatch(showPackagingExecutionRead(selectedSite.objectId, selectedDate))
	}

  // Compute next TODO recipe PE
  const nextTodo = React.useMemo(
    () => getNextToDoRecipe(packagingExecutions),
    [packagingExecutions]
  )

	// Open next recipe PE
  const goToNextTodo = () => {
    if (!nextTodo) return
    dispatch(showPackagingExecution(selectedSite.objectId, selectedDate, nextTodo.objectId))
  }

	return (
		<>
			<PackagingExecutionHeader
				leftAction={<GenericHeaderReturnButton handleClick={goToPackagingExecutionRead} />}
				subtitle={`${selectedSite.name} - ${dayjs(selectedDate).format("DD/MM/YYYY")}`}
				fixedHeader
			/>
			<Box sx={{ p: 3, marginTop: "65px" }}>
				<Stack direction="row" spacing={3}>
					<div className="flex1">
						<PackagingExecutionResume
							recipeLabel={packagingExecution.recipeName}
							status={packagingExecution.status}
							packagingLine={packagingExecution.packagingLine?.name}
							expectedPackagingNumber={packagingExecution.expectedPackagingNumber}
							uniqueCode={packagingExecution.uniqueCode}
							hasSubStatus={hasSubStatus}
							fitCornerTag={getFitCornerTag(packagingExecution.recipe)}
						/>
					</div>
				</Stack>
			</Box>
			<PEStepper
				packagings={packagingExecution.packagings}
				status={packagingExecution.status}
				times={{
					theoreticalStartTime: packagingExecution.theoreticalStartTime,
					theoreticalEndTime: packagingExecution.theoreticalEndTime,
					startTime: packagingExecution.startTime,
					endTime: packagingExecution.endTime
				}}
				withTitle={false}
			/>
			<Box sx={{ p:"32px 24px" }}>
				<Stack direction="column" spacing={2}>
						<PackagingExecutionSectionsResume sections={packagingExecution.sections}/>
					<Stack spacing={2} sx={{ marginTop: "48px !important" }}>
						<PEBlockHead title="Barquettes" icon="chart" />
						<PEPackagings packagings={getOrderedPEPackagingsWithNoTypes(packagingExecution.packagings)} />
					</Stack>
					<PackagingByBrandAndTypeTable
						packagings={packagingExecution.packagings}
						brands={ACTIVE_KFC_BRANDS}
						statusDone={true}
					/>
				</Stack>
				{hasCappedPackaging(packagingExecution) && (
					<Stack spacing={2} sx={{ marginTop: "48px" }}>
						<PEGazTest
							gazTests={gazTests}
							PEDone={true}
						/>
					</Stack>
				)}
			</Box>

			<PackagingExecutionFooter
				className="center"
				fixed
				rightAction={
					<Stack direction="row" spacing={2}>
						<Button variant={ nextTodo ? "outlined" : "contained"} onClick={goToPackagingExecutionRead}>
							Revenir aux recettes
						</Button>
						{/* Hide button if no more TODO recipes */}
						{nextTodo && (
							<Button variant="contained" onClick={goToNextTodo}>
								Passer à la recette suivante
							</Button>
						)}
					</Stack>
				}
			/>
		</>
	)
}

export default PackagingExecutionDone